import { toast } from "sonner";
import { downloadUrl } from "@/lib/api";

export const UNIT_MONEY = new Set(["money", "money2"]);

export function fmtKpi(v, unit) {
  if (v === null || v === undefined) return "N/A";
  const n = Number(v);
  if (unit === "money2") return n.toLocaleString("en-AU", { style: "currency", currency: "AUD", minimumFractionDigits: 2 });
  if (unit === "money") return n.toLocaleString("en-AU", { style: "currency", currency: "AUD", maximumFractionDigits: n % 1 ? 2 : 0 });
  if (unit === "pct") return `${n.toFixed(1)}%`;
  if (unit === "ratio") return n.toFixed(2);
  return n.toLocaleString("en-AU");
}

const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function dmy(iso, withYear = false) {
  if (!iso) return "—";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return withYear ? `${d}-${MON[+m - 1]}-${y}` : `${d}-${MON[+m - 1]}`;
}

export function weekLabel(w, withYear = false) {
  return `${dmy(w.week_start)} – ${dmy(w.week_end, withYear)}`;
}

export const STATUS_META = {
  none: { label: "Not generated", cls: "border-dashed border-zinc-300 text-zinc-500 bg-white" },
  draft: { label: "Draft", cls: "border-zinc-300 text-zinc-700 bg-zinc-100" },
  review: { label: "In review", cls: "border-amber-300 text-amber-800 bg-amber-50" },
  approved: { label: "Approved", cls: "border-emerald-300 text-emerald-800 bg-emerald-50" },
  locked: { label: "Locked", cls: "border-zinc-900 text-white bg-zinc-900" },
};

export function toneCls(status) {
  if (status === "good") return "text-emerald-700";
  if (status === "bad") return "text-red-600";
  return "text-zinc-900";
}

export function isWeekStart(iso) {
  if (!iso) return false;
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d)).getUTCDay() === 6;
}

export async function downloadFile(path, params, filename) {
  const res = await fetch(downloadUrl(path, params), { credentials: "include" });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    let detail = text;
    try { detail = JSON.parse(text).detail || text; } catch { /* plain text */ }
    throw new Error(detail || `HTTP ${res.status}`);
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch {
    /* toast link below is the fallback */
  }
  toast.success("Download ready", {
    duration: 60000,
    description: (
      <a href={url} download={filename} className="underline font-medium" data-testid="kpi-download-toast-link">
        Save {filename}
      </a>
    ),
  });
  return res.headers;
}

export function errMsg(e) {
  return e?.response?.data?.detail || e?.message || "Something went wrong";
}
